<template>
    <div class="menu-container">
        <!-- <a href="./" class="home item">
            <Icon type="shouye1" />
            <span class="home-text text">首页</span>
        </a>
        <a href="./blog" class="acticle item">
            <Icon type="weibiaoti--" />
            <span class="acticle-text text">文章</span>
        </a>
        <a href="./about" class="about-me item">
            <Icon type="guanyuwomen" />
            <span class="about-me-text text">关于我</span>
        </a>
        <a href="./project" class="project item">
            <Icon type="xiangmu" />
            <span class="project-text text">项目&效果</span>
        </a>
        <a href="./message" class="message item">
            <Icon type="liuyan" />
            <span class="message-text text">留言板</span>
        </a> -->

        <RouterLink :exact="item.exact" v-for="(item, index) in items" :key='index' class="item" :to="{name:item.name}"
            :class="{ active: isActive(item) }">
            <Icon :type="item.icon" />
            <span class="text">{{ item.title }}</span>
        </RouterLink>
    </div>
</template>

<script>
import Icon from '../Icon'
export default {
    components: {
        Icon
    },
    data() {
        return {
            items: [
                {
                    name: 'Home',
                    title: '首页',
                    icon: 'shouye1',
                    exact:true
                },
                {
                    name: 'Blog',
                    title: '文章',
                    icon: "weibiaoti--",
                    exact:false
                },
                {
                    name: 'About',
                    title: '关于我',
                    icon: "guanyuwomen",
                    exact:true
                },
                {
                    name: 'Project',
                    title: '项目&效果',
                    icon: "xiangmu",
                    exact:true

                },
                {
                    name: 'Message',
                    title: '留言板',
                    icon: "liuyan",
                    exact:true
                },
            ]
        }
    },
    methods: {
        isActive(path) {
            let link = path.link
            let currentPath = location.pathname
            if (path.StartWith) {
                return currentPath.startsWith(link)
            } else {
                return link == currentPath
            }
        }
    }
}
</script>

<style lang="less">
.menu-container {

    width: 100%;

    .item {
        text-decoration: none;
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 40px;
        position: relative;
    }

    .item:hover {
        cursor: pointer;


        .iconfont,
        .text {
            color: #fff;
        }
    }

    // .active {
    //     background: #202020;

    //     .iconfont,
    //     .text {
    //         color: #fff;
    //     }
    // }
    .router-link-active {
        background: #202020;

        .iconfont,
        .text {
            color: #fff;
        }
    }

    .iconfont,
    .text {
        color: #999;
    }

    .iconfont {
        font-size: 18px;
    }

    .text {
        position: absolute;
        margin-left: 8px;
        font-size: 16px;
    }
}
</style>